import React, { useCallback, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { useRouteMatch, Link } from 'react-router-dom'
import { ArrowDownIcon, ArrowDropUpIcon, Button, ButtonMenu, ButtonMenuItem, Checkbox, ChevronUpIcon, Flex, HelpIcon, Modal, Text, Toggle } from '@pancakeswap-libs/uikit'
import useI18n from 'hooks/useI18n'
import ExpandableSectionButton from 'components/ExpandableSectionButton'
import BigNumber from 'bignumber.js'
import QuestionHelper from 'components/QuestionHelper'
import { apyModalRoi, calculateCakeEarnedPerThousandDollars } from 'utils/compoundApyHelpers'

import BalanceTran from './BalanceTran'
import DateSelection from './DateSelection'
import ExpectedProfit from './ExpectedProfit'
import RoiInfo from './RoiInfo'
import { getInterestBreakdown, getPrincipalForInterest, getRoi } from './compoundApyHelpers'

const UsdButton = styled(Button)`
    height: 20px;
    font-size: 12px;
`

const TimeDiv = styled.div`
    width: 100%;
    opacity: 1;
    background-color: rgb(239, 244, 245);
    border-radius: 16px;
    display: inline-flex;
    border: 1px solid rgb(233, 234, 235);
 
    Button{
        &.activeLi{
            background-color: transparent;
            color: #f98c08;
            box-shadow: none;
            :hover{
                background-color: transparent !important;
                border-color: currentColor;
            }
            :focus{
                box-shadow:none
            }
        }
    }
`
const PriceContainer = styled.div`
     margin-top: 8px;
`
export interface RoiProps {
    pledgeMode:number
    onDismiss?: () => void
    lpLabel?: string
    tokenPrice?: BigNumber,
    apy?: BigNumber
    lpPrice:BigNumber,

    tokenBalance: BigNumber,
    stakedBalance: BigNumber,
    userDataState:boolean,
    multiplier:string,
    harvestTokenSymbol?: string
}

const Roi: React.FC<RoiProps> = ({
    pledgeMode,
    onDismiss,
    lpLabel,
    tokenPrice,
    apy,
    lpPrice,
    userDataState,
    multiplier,
    tokenBalance,
    stakedBalance,
    harvestTokenSymbol

}) => {
  const TranslateString = useI18n();

  /**
    * BalanceTran 输入demo
    * 快捷USD 选择 $100，$1000
  */
  const [priceU,setPriceU]=useState('');
  const [showExpandableSection, setShowExpandableSection] = useState(false)
  /**
    * DateSelection 输入demo
    * 时间选择组件返回值 day
  */
  const [day,setDay]=useState(3);
  const [dayTwo,setDayTwo]=useState(0);
  const Dates=[
  {idx:0,label:`1${TranslateString(713,'D')}`,val:1},
  {idx:1,label:`7${TranslateString(713,'D')}`,val:7},
  {idx:2,label:`30${TranslateString(713,'D')}`,val:30},
  {idx:3,label:`1${TranslateString(714,'Y')}`,val:365},
  {idx:4,label:`5${TranslateString(714,'Y')}`,val:1825}]
  const DateTwo=[
  {idx:0,label:`1${TranslateString(713,'D')}`,val:1},
  {idx:1,label:`7${TranslateString(713,'D')}`,val:7},
  {idx:2,label:`14${TranslateString(713,'D')}`,val:14},
  {idx:3,label:`30${TranslateString(713,'D')}`,val:30}]
  /**
    * 复投利率配置
  */
  const [compoundingIndexToFrequency,setCompoundingIndexToFrequency] =useState({
    0: 1,
    1: 0.142857142,
    2: 0.071428571, // once every 7 days
    3: 0.033333333, // once every 30 days
  })
  /**
    * 是否开启修改开关
  */
  const [showIsOpen,setShowIsOpen]=useState(false);
   /**
    * 是否打开复投日期
  */
  const [checkBox,setCheckBox]=useState(1);

  /**
      * 实现算法
      * earnDay 收益时间（天），复投时间earnRedelivery 单位（天）,快捷金额选择Usd 100$
  */
  const calculateEarnings=useCallback((earnDay:number,earnRedelivery:number,Usd:string):{
      roiUSD: string
      roiTokens:number,
      roiPercentage:number
    }=>{
      const principalInUSDAsNumber = parseFloat(Usd)
      // 复合利率
      const compoundNumber=(checkBox===0? 0:compoundingIndexToFrequency[earnRedelivery]);
      const stakingDuration=earnDay;
      const earningTokenPrice=tokenPrice.toNumber()

      const interestBreakdown = getInterestBreakdown({
        principalInUSD: principalInUSDAsNumber,
        apr:apy.times(100).toNumber() || 31.3269637826233 ,
        earningTokenPrice,
        compoundFrequency:compoundNumber,
        performanceFee:0,
      })
  
     
      
      const hasInterest = !Number.isNaN(interestBreakdown[stakingDuration])
      const roiTokens = hasInterest ? interestBreakdown[stakingDuration] : 0
      const roiAsUSD = hasInterest ? roiTokens * earningTokenPrice : 0
      const roiPercentage = hasInterest
        ? getRoi({
            amountEarned: roiAsUSD,
            amountInvested: principalInUSDAsNumber,
          })
        : 0  

      return { 
       roiUSD:roiAsUSD.toString(),
       roiTokens, 
       roiPercentage }
      // return earnDay*earnRedelivery*parseFloat(Usd)
  },[compoundingIndexToFrequency,checkBox,apy,tokenPrice])

  
  /**
      * priceU 变化监听日期，复利日期，快捷usd变化
  */
  useEffect(()=>{
    if(showIsOpen===false){
      const data=calculateEarnings(day,dayTwo,priceU);
      setAtta(data);
      setExpectedParam(`${data.roiUSD}`)  
    }
  },[day,dayTwo,priceU,showIsOpen,calculateEarnings])


  /**
    * ExpectedProfit  价格修改组件 输入demo
    * 时间选择组件返回值 day
  */
  const [expectedParam,setExpectedParam]=useState('35.55');
  const [atta,setAtta]=useState({ roiUSD: '',roiTokens:0,roiPercentage:0});

   /**
      * 实现算法
      * 根据输入的收益，算出需要多少USD
  */
  const calculatePriceU=useCallback((expected:string)=>{
    // expected.toUpperCase('en',{minimumFractionDigits: roiAsUSD > 100000 ? 0 : 2,maximumFractionDigits: roiAsUSD > 100000 ? 0 : 2})
      const principalForExpectedRoi = getPrincipalForInterest(
        parseFloat(expected),
        apy.times(100).toNumber() || 31.3269637826233,
        checkBox===0 ? 0:compoundingIndexToFrequency[dayTwo] ,
        0,
      )
      const principalUSD = !Number.isNaN(principalForExpectedRoi[day])
        ? principalForExpectedRoi[day]
        : 0
      const principalToken = new BigNumber(principalUSD).div(125.95094740129815)
      const roiPercentage = getRoi({
        amountEarned: parseFloat(expected),
        amountInvested: principalUSD,
      })
      return {
        amountEarned: parseFloat(expected), 
        amountInvested:principalUSD.toFixed(2), 
        roiPercent:roiPercentage 
      }
  },[day,dayTwo,checkBox,compoundingIndexToFrequency,apy])

  useEffect(()=>{
    if(showIsOpen){
     
      const data=calculatePriceU(expectedParam);
      const datas=calculateEarnings(day,dayTwo,priceU);
      setAtta(datas);
      setPriceU(`${data.amountInvested}`);
    }
  },[expectedParam,showIsOpen,calculatePriceU,calculateEarnings,day,dayTwo,priceU])

  // 详细信息计算
  const cakePrice=tokenPrice;
  const farmApy = apy.times(new BigNumber(100)).toNumber()
  const oneThousandDollarsWorthOfCake = 1000 / tokenPrice.toNumber()
  const cakeEarnedPerThousand365D = calculateCakeEarnedPerThousandDollars({ numberOfDays: 365,farmApy, cakePrice})
  const [roiInfoInput,setRinInfoInput]=useState({
    baseApr:`${apy.times(100).toFixed(2)}%`,
    // apy: `${apy.times(100).toFixed(2)}%`,
    apy: `${apyModalRoi({ amountEarned: cakeEarnedPerThousand365D, amountInvested: oneThousandDollarsWorthOfCake })}%`,
    multiplier
  });


  const stakedBalanceVal=new BigNumber(stakedBalance || 0);
  const tokenBalanceVal=new BigNumber(tokenBalance || 0);
  const lpTotalPirice =(stakedBalanceVal).plus(tokenBalanceVal);

  const setPrincipalFromUSDValue=()=>{
    const amount=(new BigNumber(lpTotalPirice)).times(lpPrice)
    if(pledgeMode===2){
      // 牧场LP总价值，不需要转换
      return amount.toFixed(18).toString()
    }
    // 农场，单币池 LP总价值转换
    const tokenPriceVal= new BigNumber(amount).dividedBy(new BigNumber(10).pow(18))
    return tokenPriceVal.toFixed(18).toString()
  }
 
  
  return (
    <Modal  title={TranslateString(712,'ROI Calculator')} onDismiss={()=>{onDismiss()}}>

            <Text bold small >{lpLabel} {TranslateString(700,'STAKED')}</Text>
            {/* 投入usd */}
            <BalanceTran 
                lpPrice={lpPrice.toNumber()}
                setShowIsOpen={setShowIsOpen} 
                priceUsd={priceU} 
                changeUsd={setPriceU}
                lpLabel={lpLabel}/>
           
            
            <PriceContainer>
                <Flex justifyContent='flex-start' alignItems="center" >
                    <Flex flex={1} justifyContent='space-around'>
                        <UsdButton size="sm" variant='tertiary' onClick={()=>{setShowIsOpen(false);setPriceU('100')}}>
                            $100
                        </UsdButton>
                        <UsdButton size="sm" variant='tertiary'  onClick={()=>{setShowIsOpen(false);setPriceU('1000')}}>
                            $1000
                        </UsdButton>
                     </Flex>
                     <Flex flex={1} justifyContent='flex-end' alignItems="center">
                   
                       <UsdButton
                          disabled={!userDataState || !lpTotalPirice.isFinite() || lpTotalPirice.lte(0)}
                          size="sm"
                          p="4px 16px"
                          variant="tertiary"
                          onClick={() =>setPriceU(setPrincipalFromUSDValue())}
                        >
                          {/* setPrincipalFromUSDValue(getBalanceNumber(stakingTokenBalance.times(stakingTokenPrice)).toString()) */}
                          {TranslateString(710,'My Balance')}
                        </UsdButton>
                 
                        {BalanceHelp(pledgeMode,lpLabel)}
                      </Flex> 
                  <Flex/>
                </Flex>
            </PriceContainer>

            {/* 日期选择 */}
            <Text bold small mt='24px' >{TranslateString(701,'STAKED FOR')}</Text>
            <Flex>
             <DateSelection selectDayIdx={day} Date={Dates}  selectDay={setDay} isDisbale={1} width='100%' />
            </Flex>
        
             <>
             <Text bold small mt='24px' >{TranslateString(702,'COMPOUNDING EVERY')}</Text>
             <Flex justifyContent='space-between'>
 
                 <Flex alignItems="center">
                   <Checkbox checked={checkBox===1} scale="sm" onChange={()=>{setCheckBox(checkBox===0?1:0)}} />
                 </Flex>
               
                 <DateSelection selectDayIdx={dayTwo}  Date={DateTwo}  selectDay={setDayTwo} isDisbale={checkBox} width='80%'/>
             </Flex>
             </>
             {/* :""
            } */}
          
            {/* day:{day} two:{dayTwo} */}

            {/* 收益编辑 */}
            <Flex justifyContent='center' my='24px' style={{height: "28px"}}>
                {
                    showIsOpen?<ChevronUpIcon color="primary" />:
                    <ArrowDownIcon color="primary" />
                    
                }
            </Flex>
             {/* 修改价格组件 */}
            <ExpectedProfit 
              harvestTokenSymbol={harvestTokenSymbol}
              atta={atta}
              onState={()=>setShowIsOpen(!showIsOpen)} 
              isOpen={showIsOpen}
              expectedRoi={expectedParam}
              handleExpectedRoiChange={setExpectedParam}
              earningTokenSymbol={lpLabel}
              />

            {/* 隐藏组件 */}
            <Flex mt='24px' justifyContent='center'>
             <ExpandableSectionButton 
               onClick={() => setShowExpandableSection(!showExpandableSection)}
               expanded={showExpandableSection}/>
            </Flex>
            {showExpandableSection?<RoiInfo pledgeMode={pledgeMode} {...roiInfoInput}/>:""}
            
  
    </Modal>
  )
}
const BalanceHelp=(pledgeMode:number,lpLabel:string)=>{
  const TranslateString = useI18n();
  if(pledgeMode===0){
    return <QuestionHelper text={TranslateString(711,"“My Balance” here includes both LP Tokens in your wallet, and LP Tokens already staked in this farm.")} />
  } 
  if(pledgeMode===1){
    return <QuestionHelper text={TranslateString(711,"“My Balance” here includes both LP Tokens in your wallet, and LP Tokens already staked in this farm.").replace(/LP/g,lpLabel)} />
  } 
  if(pledgeMode===2){
    return <QuestionHelper text={TranslateString(711,"“My Balance” here includes both LP Tokens in your wallet, and LP Tokens already staked in this farm.")} />
  }
  return ''
}


export default Roi

